// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"81b0dff7","498":"95b9b50c","513":"2a7754c9","787":"d835b4a4"}[chunkId] + ".chunk.js";
};